import React, { useContext, useEffect } from "react";
import "./SessionList.scss";

import { Button, Modal } from "react-bootstrap";
import PagingTable from "../components/PagingTable";
import AppOptionsDialog from "../options/AppOptionsDialog";
import { useTranslation } from "react-i18next";
import { SessionContext } from "./state/SessionContext";
import { SESSION_ACTIONS } from "./state/SessionReducer";
import SessionResults from "./SessionResults";
import SessionListToolbar from "./SessionListToolbar";
import SessionListMenuItems from "./SessionListMenuItems";
import XeesterBreadcrumb from "../navigation/breadcrumb/XeesterBreadcrumb";

function SessionList(props) {

  const { sessionState, dispatchSessionState } = useContext(SessionContext);

  const doDelete = () => {
    dispatchSessionState({
      type: SESSION_ACTIONS.DELETE,
      callback: ()=>{
        console.log("callback 1");
        dispatchSessionState({
          type: SESSION_ACTIONS.LOAD,
          params : props.match.params,
          batch : 0,
          callback : (data)=>{
            console.log("callback 2", data);
            dispatchSessionState({
              type: SESSION_ACTIONS.DATA_UPDATED,
              payload: data
          });
          }
        });
      }
    });
  }

  const { t } = useTranslation();

  useEffect(() => {
    console.log("sessionlist effect");
    return (() => {
      console.log("sessionlist effect done");
    });
  }, [props.match]);

  return (
    <>
      <AppOptionsDialog></AppOptionsDialog>
      <Modal
        centered
        backdrop="static"
        show={sessionState.confirmDeletion}
        dialogClassName="deletion-confirm-dialog"
        onHide={() => { }}
      >
        <Modal.Header>
          <Modal.Title>
            <Button
              onClick={() => {
                dispatchSessionState({
                  type: SESSION_ACTIONS.CONFIRM_DELETION,
                  payload: false
                });
              }}
            >
              X
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{sessionState.selectedRows.length > 1 ? t("app.session.deleteMessage.plural").replace("[NB]", sessionState.selectedRows.length) : t("app.session.deleteMessage.singular")}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              dispatchSessionState({
                type: SESSION_ACTIONS.CONFIRM_DELETION,
                payload: false
              });
            }}
          >
            {t("app.cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              dispatchSessionState({
                type: SESSION_ACTIONS.CONFIRM_DELETION,
                payload: false
              });
              doDelete();
            }}
          >
            {t("app.delete")}
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="background-container"></div>
      <div className="center-content">
        <XeesterBreadcrumb {...props}></XeesterBreadcrumb>
        <SessionResults {...props}></SessionResults>
        <PagingTable {...props} state={sessionState} dispatchState={dispatchSessionState} rendererName="session" reducerActions={SESSION_ACTIONS} toolbar={<SessionListToolbar {...props}></SessionListToolbar>} contextMenuItems={<SessionListMenuItems {...props}></SessionListMenuItems>}></PagingTable>
      </div>
    </>
  );
}
export default SessionList;
